import { capturePaymentReturn } from './lib/paymentReturn';

// ═══════════════════════════════════════════════════════════════════
// BEFORE ANYTHING ELSE READS THE ADDRESS (#508).
//
// Imported FIRST by `main.tsx`, for its side effect alone: an ES module is
// evaluated in import order, so this runs before the modules that decide the
// surface and the view from `location` — and the address they read is already
// the one the member left from, with Stripe's parameters (and the client
// secret among them) gone. See `lib/paymentReturn.ts`.
// ═══════════════════════════════════════════════════════════════════

if (typeof window !== 'undefined') {
  capturePaymentReturn(window.location, window.history);
}
